import React from "react";
import { Route } from "react-router-dom";
import { RouteGuard } from "../../../components/route-guard";
import { LoginPage } from "../../../features/auth";
import QRScannerCameraTab from "../../../features/qr-scanner/components/QRScannerCameraTab";
import ScannedAttendeesTab from "../../../features/qr-scanner/components/ScannedAttendeesTab";
import ScannerEventLayout from "../../../features/qr-scanner/components/ScannerEventLayout";
import QRScannerWelcome from "../../../features/qr-scanner/QRScannerWelcome";
import { AUTH_ROLES } from "../appRouteMatchers";

const protectedRoute = (element: React.ReactElement) => (
  <RouteGuard allowedRoles={AUTH_ROLES}>{element}</RouteGuard>
);

export const qrScannerRoutes = (
  <>
    <Route path="login" element={<LoginPage />} />
    <Route path="welcome" element={<QRScannerWelcome />} />
    <Route path="event/:id" element={protectedRoute(<ScannerEventLayout />)}>
      <Route path="camera" element={<QRScannerCameraTab />} />
      <Route path="attendees" element={<ScannedAttendeesTab />} />
    </Route>
  </>
);
